export const staticUrl = (filename: string): string => {
    return `/hstc/${HatsVersion}/${filename}`;
};
